import { ClientApi } from "@/types/inboundWebhookPayload";
import { computed, ref, watch } from "vue";
import { useConversation } from "@/composables/conversation";
import { useWidgetTheme } from "@/composables/widgetTheme";

const clientConfig = ref<ClientApi>();

export function useClientApi() {
  const { openWidget } = useConversation();
  const { setTheme } = useWidgetTheme();

  const setClientConfig = (state: ClientApi) => {
    if (state.theme) {
      setTheme(state.theme);
    }

    clientConfig.value = {
      ...clientConfig.value,
      ...state,
    };
  };

  watch(
    () => clientConfig.value?.openOnLoad,
    () => {
      if (clientConfig.value?.openOnLoad === true) {
        openWidget();
      }
    }
  );

  return {
    setClientConfig,
    clientConfig: computed(() => clientConfig.value),
  };
}
